import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Popup from 'reactjs-popup'

import Button from 'srcReact/components/common2/Button'
import InvitationItem from './InvitationItem'
import colorVariables from 'srcReact/assets/scss/global/base/_variables.scss'
import styles from './styles.module.scss'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { loginActions } from 'srcReact/LoginPage/actions'
import { useDispatch } from 'react-redux'

const initList = (selection) => {
  return selection
    .split(',')
    .filter((e) => e)
    .map((e) => parseInt(e))
}

const WorkplaceInvitation = ({
  setCurrentStep,
  currentState,
  setCurrentState,
  organizations,
  workplace_invitations
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [noWPSelectedError, setNoWPSelectedError] = useState(false)
  const [selectedInvites, setSelectedInvites] = useState(initList(currentState.workplaceInvitationsSelected || ''))

  const handleClickInvite = (invite) => {
    const isAlreadyInsideList = selectedInvites.some((i) => i === invite.id)

    if (!isAlreadyInsideList) {
      setSelectedInvites([...selectedInvites, invite.id])
    } else {
      setSelectedInvites([...selectedInvites.filter((i) => i !== invite.id)])
    }
  }

  const invites =
    workplace_invitations &&
    workplace_invitations
      .filter((e) => {
        return e.organization_id.toString() == currentState.selectedOrgId
      })
      .map((e, i) => {
        return (
          <InvitationItem
            key={i}
            letters={e.initials}
            name={e.name}
            color={e.color}
            organizationPicture={e.organization_picture}
            checked={selectedInvites.includes(e.id)}
            handleClick={() => {
              handleClickInvite(e)
            }}
          />
        )
      })

  const plural = invites.length > 1 ? 's' : ''

  const finalResult = selectedInvites.join(',')
  const contentStyle = {
    background: colorVariables.darkgray,
    color: colorVariables.whitecolor,
    width: '19rem',
    height: '3rem',
    marginBottom: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }

  const handleJoin = () => {
    if (finalResult.length === 0) {
      setNoWPSelectedError(true)
    } else {
      setNoWPSelectedError(false)
      setCurrentState({
        ...currentState,
        workplaceInvitationsSelected: finalResult
      })

      const { email, selectedOrgId, password } = currentState

      if (email && password) {
        dispatch(loginActions.loginWithWorkplace(email, password, selectedOrgId, finalResult))
      }
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.container1}>
        <div>
          {t('signup.invitation_module.found')} {invites.length} {t('signup.invitation_module.invitation')}
          {plural} {t('signup.invitation_module.for')} {currentState.email}
        </div>
        <div className={styles.change}></div>
        <div>{invites}</div>
        {noWPSelectedError && (
          <ErrorMessage text={t('signup.invitation_module.join_tooltip')} className={styles.error} />
        )}
      </div>

      <div className={styles.buttonContainer}>
        <Button
          text={t('signup.invitation_module.back')}
          size='large'
          style='secondary'
          handleClick={() => setCurrentStep('org-selection')}
        />
        <Popup
          open={true}
          position={'top center'}
          on={['hover', 'focus']}
          contentStyle={contentStyle}
          arrowStyle={{ color: colorVariables.darkgray }}
          trigger={
            <button type='button' className={styles.confirmButton} onClick={handleJoin}>
              {t('signup.invitation_module.join')}
            </button>
          }>
          <span className={styles.tooltip}> {t('signup.invitation_module.join_tooltip')}</span>
        </Popup>
      </div>
    </div>
  )
}

export default WorkplaceInvitation
